// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"92":"00ca9d46","208":"b95c8f7b","643":"0e02bb73","734":"a484f421","835":"d07b96bf"}[chunkId] + ".chunk.js";
};